import React from "react";
import { observer } from "mobx-react";
import { WeaPeriod } from "ecCom";

@observer
export default class PeriodItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaPeriod
        ecId={`${this.props.ecId}_WeaPeriod@coukni`}
        {...bindObj.bind()}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/PeriodItem.js